var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen flex w-full bg-img vx-row no-gutter helpdesk-form"},[_c('iframe',{staticClass:"clickup-embed",staticStyle:{"background":"transparent","border":"1px solid #ccc"},attrs:{"src":"https://sharing.clickup.com/b/h/6-13759881-2/257656ecf5d9951","onwheel":"","width":"100%","height":"100%"}})])
}]

export { render, staticRenderFns }